import { CalendarIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { Alert, Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { ChatEnum } from '../../../../Chat.enum';
import { useMessageBarContext } from '../../MessageBar.hook';
import { useAgendaActionContext } from './AgendaAction.context';
import './AgendaAction.styles.scss';
import CreateEvent from './components/CreateEvent.component';
import NoTemplates from './components/EmptyState.component';

export default function AgendaActionContent() {
  const { setSelectedAction } = useMessageBarContext();
  const { templates } = useAgendaActionContext();
  const { t } = useTranslation('chat/chat');

  return (
    <div className="AgendaAction">
      <Alert
        icon={<CalendarIcon className="w-6 h-6" aria-hidden="true" />}
        className="AgendaAction__Alert"
      >
        <span>{t('agendaAction.title')}</span>
        <Button
          color="ghost"
          variant="link"
          size="xs"
          className="px-0"
          onClick={() => setSelectedAction(ChatEnum.CHAT)}
        >
          <XMarkIcon className="w-6 h-6" />
        </Button>
      </Alert>

      {templates.length ? <CreateEvent /> : <NoTemplates />}
    </div>
  );
}
